import { render, staticRenderFns } from "./location-edit-modal.vue?vue&type=template&id=38a86494&"
import script from "./location-edit-modal.vue?vue&type=script&lang=js&"
export * from "./location-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports